import React from 'react';
import PropTypes from 'prop-types';
import { uniqueId, noop } from 'lodash';
import { pure } from '@dbk/ui-react-utils';

const DropdownContainer = ({
  id,
  children,
  dropdownWrapperClass,
  tabIndex,
  dropdownRef,
  childId,
  isOpen,
  testID,
  eventHandlers,
}) => (
  <div
    id={id}
    className={dropdownWrapperClass}
    tabIndex={tabIndex}
    ref={dropdownRef}
    role="listbox"
    aria-labelledby={childId}
    aria-expanded={isOpen.toString()}
    data-test-id={testID}
    {...eventHandlers}
  >
    {children}
  </div>
);

DropdownContainer.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.array,
  ]),
  dropdownWrapperClass: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dropdownRef: PropTypes.func,
  childId: PropTypes.string,
  isOpen: PropTypes.bool,
  testID: PropTypes.string,
  eventHandlers: PropTypes.object,
};

DropdownContainer.defaultProps = {
  id: uniqueId('dropdown'),
  children: [],
  dropdownWrapperClass: 'dropdown dropdown__target dropdown--medium',
  tabIndex: 0,
  dropdownRef: noop,
  childId: uniqueId('dropdown_selected'),
  isOpen: false,
  testID: uniqueId(),
  eventHandlers: {},
};

export default pure(DropdownContainer);
